<div class="flex flex-col items-center" *transloco="let t; read: 'calculator_result.save_power_plant'">
  <form [formGroup]="formGroup" class="flex flex-col gap-4 self-start w-full">
    <psc-input
      formControlName="name"
      [label]="t('name')"></psc-input>

    <psc-input
      formControlName="investor"
      [label]="t('investor')"></psc-input>

    <psc-input
      formControlName="address"
      [label]="t('address')"></psc-input>

    <psc-file-input
      formControlName="image"
      [label]="t('image')"></psc-file-input>

    <div class="flex gap-3">
      <psc-button
        [label]="buttonText || t('save')"
        [disabled]="!formGroup.valid"
        type="primary-blue-2"
        (buttonClicked)="submit()"></psc-button>

      <psc-button
        [label]="t('cancel')"
        type="secondary-magenta"
        (buttonClicked)="canceled.emit()"></psc-button>
    </div>
  </form>
</div>
